var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconShare = function SvgIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16.842 8.425a2.681 2.681 0 1 0 0-5.362 2.681 2.681 0 1 0 0 5.362M6.117 14.681a2.681 2.681 0 1 0 0-5.362 2.681 2.681 0 0 0 0 5.362M16.842 20.938a2.681 2.681 0 1 0 0-5.363 2.681 2.681 0 0 0 0 5.363M8.431 13.35l6.104 3.557m-.008-9.814L8.43 10.65"
  })));
};
export default SvgIconShare;